'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-1887e1af.js');
var React = require('react');
var styled = require('styled-components');
var constants_properties = require('../../constants/properties.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var calculateSize = function (_a) {
    var size = _a.size;
    switch (size) {
        case constants_properties.SVG_ICON_SIZES.XL:
            return '72px';
        case constants_properties.SVG_ICON_SIZES.LARGE:
            return '48px';
        case constants_properties.SVG_ICON_SIZES.MEDIUM:
            return '24px';
        case constants_properties.SVG_ICON_SIZES.SMALL:
        default:
            return '16px';
    }
};
var calculateColor = function (_a) {
    var color = _a.color, _b = _a.theme.colors.icon, primary = _b.primary, secondary = _b.secondary, disabled = _b.disabled, negative = _b.negative, warning = _b.warning, positive = _b.positive, interactive = _b.interactive, light = _b.light;
    switch (color) {
        case constants_properties.SVG_ICON_COLORS.SECONDARY:
            return secondary;
        case constants_properties.SVG_ICON_COLORS.DISABLED:
            return disabled;
        case constants_properties.SVG_ICON_COLORS.NEGATIVE:
            return negative;
        case constants_properties.SVG_ICON_COLORS.WARNING:
            return warning;
        case constants_properties.SVG_ICON_COLORS.POSITIVE:
            return positive;
        case constants_properties.SVG_ICON_COLORS.INTERACTIVE:
            return interactive;
        case constants_properties.SVG_ICON_COLORS.LIGHT:
            return light;
        case constants_properties.SVG_ICON_COLORS.PRIMARY:
        default:
            return primary;
    }
};
var IconWrapper = styled__default["default"].span(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: inline-flex;\n  svg {\n    path {\n      ", "\n      ", "\n    }\n    height: ", ";\n    width: ", ";\n  }\n"], ["\n  display: inline-flex;\n  svg {\n    path {\n      ", "\n      ", "\n    }\n    height: ", ";\n    width: ", ";\n  }\n"])), function (_a) {
    var custom_stroke = _a.custom_stroke, theme = _a.theme;
    return custom_stroke &&
        "stroke: ".concat(calculateColor({ color: custom_stroke, theme: theme }), ";");
}, function (_a) {
    var custom_fill = _a.custom_fill, theme = _a.theme;
    return custom_fill &&
        "fill: ".concat(calculateColor({ color: custom_fill, theme: theme }), ";");
}, function (_a) {
    var size = _a.size;
    return calculateSize({ size: size });
}, function (_a) {
    var size = _a.size;
    return calculateSize({ size: size });
});
var SvgIcon = function (_a) {
    var stroke = _a.stroke, fill = _a.fill, size = _a.size, Icon = _a.icon, className = _a.className;
    return (React__default["default"].createElement(IconWrapper, { size: size, custom_fill: fill, custom_stroke: stroke, className: className },
        React__default["default"].createElement(Icon, { viewBox: "0 0 24 24" })));
};
var templateObject_1;

exports["default"] = SvgIcon;
